export class VendorFilterModel {
    public companyId: number;
    public vendorTypeId: string;
    public filterKey: string;

    constructor() {
        this.vendorTypeId = '';
    }
}
